import validate from "/usr/src/app/content/n3-spas-fbe8f1e9-fb66-44cf-9c53-4089b6b3b085/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-fbe8f1e9-fb66-44cf-9c53-4089b6b3b085/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}